import './App.css';
import TodoList from './components/TodoList';

function App() {
  return (
    <div className="container">
     <TodoList />
    </div>
  );
}

export default App;
